import { ComponentProps, memo, ReactNode } from 'react'
import cn from 'classnames'

interface IProps extends ComponentProps<'div'> {
  children: ReactNode
  className?: string
  isSticky?: boolean
}

export const ModalFooter = memo<IProps>(function ModalFooter({ children, className, isSticky, ...rest }) {
  return (
    <div
      {...rest}
      className={cn(
        '![&_button+button]:ml-4 relative flex items-center justify-end text-wrap rounded-bl-xl rounded-br-xl bg-surface p-6',
        className,
        {
          'b-0 sticky z-[3] after:absolute after:left-0 after:top-[-3px] after:h-[3px] after:w-full after:select-none after:bg-[linear-gradient(to_top,rgb(26,28,30,0.12),transparent)] after:content-[""]':
            isSticky
        }
      )}
    >
      {children}
    </div>
  )
})
